// Global Types
import type {
  $WebRouteResponse as $ApiRouteResponse,
} from 'common.types';

// Mocks
import {
  championshipRegattas,
  championships,
  fullChampionships,
  fullRegattaEntries,
  fullRegions,
  fullWebRegattas,
  regattas,
  regionSeasonRegattaLocations,
  regionSeasons,
} from 'common.data/dist/mocks';

// Service
import ApiService from '../ApiService';

// Types
import type {
  $Config,
} from '../ApiService';

class ApiServiceMock extends ApiService<$Config> {
  constructor(config: $Config) {
    super(config);

    this.initMock((mock) => {
      mock.onGet(this.path('/regions')).reply(() => {
        const responseBody: $ApiRouteResponse<'/regions'> = fullRegions;

        return [200, responseBody];
      });

      mock.onGet(this.path('/static/regions.json')).reply(() => {
        const responseBody = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regattas')).reply(({
        data,
      }) => {
        const body: {
          RegionId: string;
        } = JSON.parse(data);

        const foundItems = regionSeasons.filter((i) => i.RegionId === body.RegionId);

        const responseBody: $ApiRouteResponse<'/page/regattas'> = foundItems[0]
          ? foundItems[0]
          : null;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regattas/section/advertisements')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regattas/section/advertisements'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regattas/section/banners')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regattas/section/banners'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regattas/section/regattas')).reply(({
        data,
      }) => {
        const body: {
          RegionSeasonId: string;
        } = JSON.parse(data);

        const responseBody: $ApiRouteResponse<'/page/regattas/section/regattas'> = {
          Locations: regionSeasonRegattaLocations.filter((
            i,
          ) => i.RegionSeasonId === body.RegionSeasonId),
          Regattas: fullWebRegattas.filter((
            i,
          ) => i.RegionSeasonId === body.RegionSeasonId),
        };

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regattas/section/entries')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regattas/section/entries'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regattas/section/banners')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regattas/section/banners'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/championships')).reply(({
        data,
      }) => {
        const body: {
          RegionId: string;
        } = JSON.parse(data);

        const foundItems = regionSeasons.filter((i) => i.RegionId === body.RegionId);

        const responseBody: $ApiRouteResponse<'/page/championships'> = foundItems[0]
          ? foundItems[0]
          : null;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/championships/section/championships')).reply(({
        data,
      }) => {
        const body: {
          RegionSeasonId: string;
        } = JSON.parse(data);

        const foundItems = fullChampionships.filter((
          i,
        ) => i.RegionSeasonId === body.RegionSeasonId);

        const responseBody: $ApiRouteResponse<'/page/championships/section/championships'> = foundItems;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta')).reply(({
        data,
      }) => {
        const body: {
          param1: string;
          param2?: string;
        } = JSON.parse(data);

        const foundItems = regattas.filter((
          i,
        ) => i.id === body.param1 || i.Slug === body.param1);

        const responseBody: $ApiRouteResponse<'/page/regatta'> = foundItems[0]
          ? foundItems[0]
          : null;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/advertisements')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/advertisements'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/banners')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/banners'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/boat_rents')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/boat_rents'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/championships')).reply(({
        data,
      }) => {
        const body: {
          RegattaId: string;
        } = JSON.parse(data);

        const foundItems = championships.filter((
          i,
        ) => championshipRegattas.filter((
          ii,
        ) => ii.ChampionshipId === i.id && ii.RegattaId === body.RegattaId).length > 0);

        const responseBody: $ApiRouteResponse<'/page/regatta/section/championships'> = foundItems;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/contacts')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/contacts'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/documents')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/documents'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/entries')).reply(({
        data,
      }) => {
        const body: {
          RegattaId: string;
        } = JSON.parse(data);

        const foundItems = fullRegattaEntries.filter((i) => i.RegattaId === body.RegattaId);

        const responseBody: $ApiRouteResponse<'/page/regatta/section/entries'> = foundItems;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/messages')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/messages'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/protests')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/protests'> = {
          RegattaDays: [],
          RegattaProtests: [],
        };

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/registration')).reply(({
        data,
      }) => {
        const body: {
          RegattaId: string;
        } = JSON.parse(data);

        const foundItems = fullWebRegattas.filter((i) => i.id === body.RegattaId);

        const responseBody: $ApiRouteResponse<'/page/regatta/section/registration'> = foundItems[0]
          ? foundItems[0]
          : null;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/results')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/results'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/results_overall')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/results_overall'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/schedules')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/schedules'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/regatta/section/sponsors')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/regatta/section/sponsors'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/championship')).reply(({
        data,
      }) => {
        const body: {
          param1: string;
          param2?: string;
        } = JSON.parse(data);

        const foundItems = fullChampionships.filter((
          i,
        ) => i.id === body.param1 || i.Slug === body.param1);

        const responseBody: $ApiRouteResponse<'/page/championship'> = foundItems[0]
          ? foundItems[0]
          : null;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/championship/section/banners')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/championship/section/banners'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/championship/section/documents')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/championship/section/documents'> = [];

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/championship/section/regattas')).reply(({
        data,
      }) => {
        const body: {
          ChampionshipId: string;
        } = JSON.parse(data);

        const foundItems = fullWebRegattas.filter((
          i,
        ) => championshipRegattas.filter((
          ii,
        ) => ii.RegattaId === i.id && ii.ChampionshipId === body.ChampionshipId).length > 0);

        const responseBody: $ApiRouteResponse<'/page/championship/section/regattas'> = foundItems;

        return [200, responseBody];
      });

      mock.onPost(this.path('/page/championship/section/results')).reply(() => {
        const responseBody: $ApiRouteResponse<'/page/championship/section/results'> = [];

        return [200, responseBody];
      });
    });
  }
}

export default ApiServiceMock;
